import { BRAND } from "@/data/portfolio";

export default function WhatsAppFab() {
  const href = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
    BRAND.whatsappMessage
  )}`;
  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="wa-fab"
    >
      <svg viewBox="0 0 32 32" width="22" height="22" fill="white" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.917 0 2.42-.602 2.793-1.494.13-.302.18-.66.18-1.018 0-.272-1.46-.96-1.748-1.06zm-2.92 7.376c-1.747 0-3.48-.46-4.985-1.348l-3.58 1.146 1.16-3.452a9.788 9.788 0 0 1-1.508-5.24c0-5.418 4.41-9.83 9.83-9.83 5.42 0 9.83 4.412 9.83 9.83 0 5.42-4.41 9.835-9.83 9.835zm0-21.484c-6.41 0-11.65 5.24-11.65 11.65 0 2.018.518 4.005 1.506 5.747L0 32l8.628-2.42c1.66.918 3.553 1.405 5.486 1.404h.001c6.41 0 11.65-5.24 11.65-11.65 0-6.413-5.244-11.647-11.654-11.647z"/>
      </svg>
    </a>
  );
}
